import { Center, Grid, Heading, VStack } from "@chakra-ui/layout";
import { Card, Spinner } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import type {
  BrandRevenueSummaryQuery,
  ProjectRevenueSummaryQuery,
} from "@src/__generated__/urql-graphql";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";
import { TopClientsGraph } from "../../../brand/common/top-clients-graph";
import type { ProjectReportStore } from "../../../project/common/store";
import { TopProjectsGraph } from "../../../project/common/top-projects-graph";
import { RevenueCard } from "../../components/revenue-card";

export type RevenueSummaryProps = (
  | {
      type: "project";
      summary: ProjectRevenueSummaryQuery["projectRevenueSummary"] | undefined;
    }
  | {
      type: "brand";
      summary: BrandRevenueSummaryQuery["brandRevenueSummary"] | undefined;
    }
) & {
  isFetching: boolean;
  expenseBudgetCategories: ProjectReportStore["expenseBudgetCategories"];
};

export const RevenueSummary: FunctionComponent<RevenueSummaryProps> = observer(
  function RevenueSummary({
    type,
    isFetching,
    summary,
    expenseBudgetCategories,
  }) {
    return (
      <Grid templateColumns="0.65fr 0.35fr" columnGap="4" p="4">
        <RevenueCard
          isFetching={isFetching}
          summary={summary}
          expenseBudgetCategories={expenseBudgetCategories}
          type={type}
        />
        <Card p="4" bg="grey.50">
          {isFetching ? (
            <Center minH="32">
              <Spinner size="xl" />
            </Center>
          ) : type === "project" ? (
            <VStack w="full" h="full" align="start">
              <Heading fontSize="xl">
                <Trans>Top Projects (by Billings)</Trans>
              </Heading>
              <TopProjectsGraph
                data={summary?.revenue_top_projects ?? []}
                expenseBudgetCategories={expenseBudgetCategories}
              />
            </VStack>
          ) : (
            <VStack w="full" h="full" align="start">
              <Heading fontSize="xl">
                <Trans>Top Clients (by Billings)</Trans>
              </Heading>
              <TopClientsGraph data={summary?.revenue_top_clients ?? []} />
            </VStack>
          )}
        </Card>
      </Grid>
    );
  },
);
